export default __webpack_public_path__ + "static/media/enhancedWebsiteSample1.5950ee9f.png";